function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStatusUvv(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "16pt",
    height: "16pt",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 7.332031 2.667969 L 3.996094 2.667969 L 4 13.332031 L 11.996094 13.332031 C 11.996094 13.332031 12 9.449219 12 7.332031 L 8 7.332031 C 7.632812 7.332031 7.332031 7.035156 7.332031 6.667969 Z M 8.667969 6 L 12 6 L 8.667969 2.667969 Z M 3.996094 1.332031 L 8.871094 1.332031 C 9.050781 1.332031 9.308594 1.441406 9.433594 1.566406 L 13.097656 5.230469 C 13.230469 5.363281 13.332031 5.621094 13.332031 5.800781 L 13.332031 13.332031 C 13.332031 14.070312 12.738281 14.667969 11.996094 14.667969 L 4.003906 14.667969 C 3.261719 14.667969 2.667969 14.066406 2.667969 13.332031 L 2.667969 2.667969 C 2.667969 1.929688 3.261719 1.332031 3.996094 1.332031 Z M 4.667969 11.332031 C 4.667969 10.964844 4.964844 10.667969 5.332031 10.667969 L 10.667969 10.667969 C 11.035156 10.667969 11.332031 10.964844 11.332031 11.332031 C 11.332031 11.699219 11.035156 12 10.667969 12 L 5.332031 12 C 4.964844 12 4.667969 11.703125 4.667969 11.332031 Z M 4.667969 9.332031 C 4.667969 8.964844 4.964844 8.667969 5.335938 8.667969 L 7.996094 8.667969 C 8.367188 8.667969 8.667969 8.964844 8.667969 9.332031 C 8.667969 9.699219 8.367188 10 7.996094 10 L 5.335938 10 C 4.964844 10 4.667969 9.703125 4.667969 9.332031 Z M 4.667969 9.332031 "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatusUvv);
export default __webpack_public_path__ + "static/media/statusUVV.68abd2950ea53c96ad575237e3b71ef4.svg";
export { ForwardRef as ReactComponent };